import { DATE_FORMAT_OPTIONS } from "@/constants/dateFormatting";

export const formatDisplayDate = (value) =>
  value
    ? new Intl.DateTimeFormat(undefined, DATE_FORMAT_OPTIONS).format(new Date(value))
    : '';